module.exports = __webpack_public_path__ + "img/logo.4eb39962.svg";